import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const evaluationsRoutes: Routes = [
  {
    title: 'pagesTitles.evaluations',
    path: APP_ROUTES.EVALUATIONS,
    canActivate: [permissionGuard(APP_PERMISSIONS.EvaluationsRead)],
    loadComponent: () =>
      import('./pages/list-evaluation').then((m) => m.ListEvaluation),
  },
  {
    title: 'pagesTitles.evaluationCreate',
    path: APP_ROUTES.EVALUATIONS_NEW,
    canActivate: [permissionGuard(APP_PERMISSIONS.EvaluationsCreate)],
    loadComponent: () =>
      import('./pages/create-evaluation').then((m) => m.CreateEvaluation),
  },
  {
    title: 'pagesTitles.evaluationDetail',
    path: APP_ROUTES.EVALUATIONS_DETAIL,
    canActivate: [permissionGuard(APP_PERMISSIONS.EvaluationsRead)],
    loadComponent: () =>
      import('./pages/show-evaluation').then((m) => m.ShowEvaluation),
  },
  {
    title: 'pagesTitles.evaluationEdit',
    path: APP_ROUTES.EVALUATIONS_EDIT,
    canActivate: [permissionGuard(APP_PERMISSIONS.EvaluationsUpdate)],
    loadComponent: () =>
      import('./pages/update-evaluation').then((m) => m.UpdateEvaluation),
  },
  {
    title: 'pagesTitles.evaluationPrint',
    path: APP_ROUTES.EVALUATIONS_PRINT,
    canActivate: [permissionGuard(APP_PERMISSIONS.EvaluationsPrint)],
    loadComponent: () =>
      import('./pages/print-evaluation').then((m) => m.PrintEvaluation),
  },
];
